import {
  ActionSheet,
  Button,
  Cell,
  CellGroup,
  Checkbox,
  CheckboxGroup,
  Col,
  Collapse,
  CollapseItem,
  DatetimePicker,
  Dialog,
  Field,
  Icon,
  List,
  Loading,
  NavBar,
  NoticeBar,
  Notify,
  NumberKeyboard,
  PasswordInput,
  Picker,
  Popup,
  Radio,
  RadioGroup,
  Rate,
  Row,
  Search,
  Step,
  Steps,
  SwipeCell,
  Tab,
  Tabbar,
  TabbarItem,
  Tabs,
  Tag,
  Toast,
  Uploader,
  Grid,
  GridItem, SubmitBar
} from 'vant';
// 自定义公用包
import TnSection from '../components/common/lib/tn-section';
import TnList from '../components/common/lib/tn-list';
import TnTag from '../components/common/lib/tn-tag';
import TnDragIcon from '../components/common/lib/drag-icon';
import TnCountDown from '../components/common/lib/count-down';
import ClassInfoList from '../components/common/biz/class-info-list';
import SignInDetail from '../components/common/biz/sign-in-detail';

const components = [
  // Badge,
  // BadgeGroup,
  Button,
  Cell,
  CellGroup,
  SwipeCell,
  Checkbox,
  CheckboxGroup,
  // Circle,
  Col,
  Collapse,
  CollapseItem,
  DatetimePicker,
  Dialog,
  Field,
  Icon,
  // ImagePreview,
  List,
  Loading,
  // Locale,
  NavBar,
  NoticeBar,
  NumberKeyboard,
  Notify,
  // Pagination,
  // Panel,
  PasswordInput,
  Picker,
  Popup,
  // Progress,
  // PullRefresh,
  Radio,
  RadioGroup,
  Rate,
  Row,
  Search,
  // Slider,
  Step,
  // Stepper,
  Steps,
  // Swipe,
  // SwipeItem,
  // Switch,
  // SwitchCell,
  Tab,
  Tabbar,
  TabbarItem,
  Tabs,
  Tag,
  Toast,
  // TreeSelect,
  Uploader,
  ActionSheet,
  Grid,
  GridItem, SubmitBar
];

const customComponents = [
  TnSection,
  TnList,
  ClassInfoList,
  TnTag,
  TnDragIcon,
  TnCountDown,
  SignInDetail
  // TnSwipeList
];

const install = Vue => {
  components.forEach(Component => {
    Vue.use(Component);
  });

  // 注册自定义公用包
  customComponents.forEach(c => {
    Vue.component(c.name, c);
  });
};

/* istanbul ignore if */
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

export default {
  install
};

